import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createB2BAPI } from '../../../api/Interceptor';
import { Carousel } from '@mantine/carousel';
import { Card } from '@mantine/core';
import _ from 'lodash';
import { BASE_URL } from '../../../api/EndPoints';
import badge from "../../../assets/badge.png";
import { useMediaQuery } from '@mantine/hooks';

const TopBottomCollectionsPMC = () => {
    const [allBottomCollections, setAllBottomCollections] = useState({});
    const [allTopCollections, setAllTopCollections] = useState({});
    const ismobile = useMediaQuery("(max-width: 767px)");
    const navigate = useNavigate();
    const [activeIndex, setActiveIndex] = useState(0);
    const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);
    const [loading, setLoading] = useState(false);
    const topCollectionsArray = Array.isArray(allTopCollections) ? allTopCollections : Object.values(allTopCollections || {});
    const allTopPims = (topCollectionsArray || []).flatMap(collection =>
        (collection.pims || []).map(pim => ({ ...pim, collectionName: collection.collectionName }))
    );
    const bottomCollectionsArray = Array.isArray(allBottomCollections) ? allBottomCollections : Object.values(allBottomCollections || {});
    const allBottomPims = (bottomCollectionsArray || []).flatMap(collection =>
        (collection.pims || []).map(pim => ({ ...pim, collectionName: collection.collectionName }))
    );

    useEffect(() => {
        fetchAllCollections();
    }, []);


    function getUniqueItemsWithCount(items) {
        const uniqueItemsMap = new Map();
        items?.forEach((item) => {
            if (uniqueItemsMap.has(item.id)) {
                uniqueItemsMap.set(item.id, uniqueItemsMap.get(item.id) + 1);
            } else {
                uniqueItemsMap.set(item.id, 1);
            }
        });
        return Array.from(uniqueItemsMap, ([id, count]) => ({ id, count }));
    }


    const renderColorCode = (productVariants) => {
        if (productVariants && productVariants.length > 0) {
            const hexaColorCodes = productVariants.flatMap((item) =>
                item.variants?.filter((variant) => variant.hexaColorCode)
            );
            return (
                <div
                    className={`colorchips ${_.size(hexaColorCodes) < 12 ? "borderable" : ""
                        }`}
                >
                    {_.map(hexaColorCodes, (hexa, index) => (
                        <div
                            key={index}
                            className="colorchip"
                            style={{ backgroundColor: hexa.hexaColorCode }}
                        ></div>
                    ))}
                </div>
            );
        } else {
            return <></>;
        }
    };
    const fetchAllCollections = async () => {
        try {
            setLoading(true);
            const res = await B2B_API.get(`pim/allCollectionFabricView?productPage=${true}`).json();
            setAllBottomCollections(res?.response?.bottom || []);
            setAllTopCollections(res?.response?.top || []);
        } catch (error) {
            console.error('Error fetching collections:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div>Loading collections...</div>;
    return (
        <div className="similar-items building-block width-limiter">
            {allTopPims?.length > 0 && (
                <>
                    <div className="title2"><span style={{ display: "flex", fontSize: "20px" }}>{allTopPims[activeIndex]?.collectionName || ''}</span></div>
                    <Carousel
                        slideSize={ismobile ? "50%" : "15%"}
                        loop
                        slideGap="md"
                        align="start"
                        slidesToScroll={ismobile ? 2 : 5}
                    >
                        {allTopPims?.map((item, index) => (
                            <Carousel.Slide
                                key={item.id || index}
                            >
                                <Card
                                    shadow="sm"
                                    padding={0}
                                    radius="md"
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        overflow: "hidden",
                                        height: "420px",
                                        minHeight: "420px",
                                        maxHeight: "420px",
                                    }}
                                    withBorder
                                    onClick={() => navigate(item.landingUrl)}
                                >
                                    <img
                                        className="product-img"
                                        src={`${BASE_URL.replace('/api', '')}${item?.image}?time=${Date?.now()}`}
                                        alt={item.articleName}
                                    />
                                    <div style={{ padding: '12px' }}>
                                        {renderColorCode(item.pimVariants)}
                                        <div>
                                            <div
                                                style={{
                                                    color: '#788191',
                                                    fontWeight: '500',
                                                    fontSize: '12px',
                                                }}
                                            >
                                                {item?.articleCode}
                                            </div>
                                            <div
                                                style={{
                                                    fontWeight: '600',
                                                    marginBottom: '8px',
                                                }}
                                            >
                                                {item?.articleName}
                                            </div>
                                        </div>
                                        <div className="quality-price">
                                            <b className="price-container">&#8377; {item.channelPrice}</b>
                                        </div>
                                        <div className="quality-info">
                                            <div className="contents">
                                                <div className="f-600 item">
                                                    <div>{item.fabricContent?.value}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ fontSize: '11px' }}>
                                            <span className="m-r-0 weight-span">
                                                <span>{item.metrics?.weight}</span>
                                                <span> gsm</span>
                                            </span>
                                            <span className="m-l-4 m-r-4 weight-span">.</span>
                                            <span className="weight-span">
                                                {item.attributes?.['Fabric Type']?.name}
                                            </span>
                                        </div>
                                        <div
                                            className="badges-quality m-t-8"
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <div className="badge-type">
                                                <img className="badge-img" src={`${badge}?time=${Date.now()}`} alt="Badge" />
                                                {_.size(getUniqueItemsWithCount(item.pimVariants))}
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            </Carousel.Slide>
                        ))}
                    </Carousel>
                </>
            )}
            <div>
                {allBottomPims?.length > 0 && (
                    <>
                        <div className="title2"><span style={{ display: "flex", fontSize: "20px" }}> {allBottomPims[activeIndex]?.collectionName || ''}</span></div>
                        <Carousel
                            slideSize={ismobile ? "50%" : "15%"}
                            loop
                            slideGap="md"
                            align="start"
                            slidesToScroll={ismobile ? 2 : 5}
                        >
                            {allBottomPims?.map((item, index) => (
                                <Carousel.Slide
                                    key={`${index.pimId || index}-${index.collectionName}`}
                                >
                                    <Card
                                        shadow="sm"
                                        padding={0}
                                        radius="md"
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            overflow: "hidden",
                                            height: "420px",
                                            minHeight: "420px",
                                            maxHeight: "420px",
                                        }}
                                        withBorder
                                        onClick={() => navigate(item.landingUrl)}
                                    // onClick={() => navigate(pim.landingUrl, { state: { collectionName: pim.collectionName } })}
                                    >
                                        <img
                                            className="product-img"
                                            src={`${BASE_URL?.replace('/api', '')}${item.image}?time=${Date?.now()}`}
                                            alt={item.articleName}
                                        />
                                        <div style={{ padding: '12px' }}>
                                            {renderColorCode(item.pimVariants)}
                                            <div>
                                                <div
                                                    style={{
                                                        color: '#788191',
                                                        fontWeight: '500',
                                                        fontSize: '12px',
                                                    }}
                                                >
                                                    {item?.articleCode}
                                                </div>
                                                <div
                                                    style={{
                                                        fontWeight: '600',
                                                        marginBottom: '8px',
                                                    }}
                                                >
                                                    {item?.articleName}
                                                </div>
                                            </div>
                                            <div className="quality-price">
                                                <b className="price-container">&#8377; {item.channelPrice}</b>
                                            </div>
                                            <div className="quality-info">
                                                <div className="contents">
                                                    <div className="f-600 item">
                                                        <div>{item.fabricContent?.value}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ fontSize: '11px' }}>
                                                <span className="m-r-0 weight-span">
                                                    <span>{item.metrics?.weight}</span>
                                                    <span> gsm</span>
                                                </span>
                                                <span className="m-l-4 m-r-4 weight-span">.</span>
                                                <span className="weight-span">
                                                    {item.attributes?.['Fabric Type']?.name}
                                                </span>
                                            </div>
                                            <div
                                                className="badges-quality m-t-8"
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <div className="badge-type">
                                                    <img className="badge-img" src={badge} alt="Badge" />
                                                    {_.size(getUniqueItemsWithCount(item.pimVariants))}
                                                </div>
                                            </div>
                                        </div>
                                    </Card>
                                </Carousel.Slide>
                            ))}
                        </Carousel>
                    </>
                )}</div>
        </div>
    );
};

export default TopBottomCollectionsPMC;
